import {
    SET_STYLIST,
    SET_STYLIST_REVIEWS,
    STYLIST_ACTION_FAILED,
    STYLIST_LOAD_START,
    STYLIST_LOADING_START,
    UPDATE_STYLIST_FAVORITES
} from './actions';

const initialState = {
    loading: false,
    stylist: {},
    reviews: [],
    looks: [],
    looksTotal: 0,
    clients: [],
    favorites: [],
    favoritesTotal: 0,
    lastMessage: {},
    error: null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case STYLIST_LOADING_START: {
            return {
                ...state,
                loading: true
            };
        }
        case STYLIST_LOAD_START: {
            return {
                ...state,
                stylist: {}
            };
        }
        case SET_STYLIST: {
            const { stylist } = action.payload;
            return {
                ...state,
                stylist
            };
        }
        case SET_STYLIST_REVIEWS: {
            const { reviews } = action.payload;
            return {
                ...state,
                reviews,
                loading: false
            };
        }
        case UPDATE_STYLIST_FAVORITES: {
            const { items, total_count } = action.payload;
            return {
                ...state,
                favorites: items,
                favoritesTotal: total_count
            };
        }

        case STYLIST_ACTION_FAILED: {
            const { error } = action.payload;
            return {
                ...state,
                error,
                loading: false
            };
        }

        default:
            return state;
    }
}
